module.exports = __webpack_public_path__ + "static/media/work.248c8e61.svg";